export default __webpack_public_path__ + "static/media/2-100.b1f7ad05.jpg";